'use client';

import { Stepper, Step, StepLabel } from '@mui/material';
import { StepConfig } from '../../type';

type Props = {
  steps: StepConfig[];
  activeStep: number;
};

const FormStepper = ({ steps, activeStep }: Props) => (
  <Stepper activeStep={activeStep} sx={{ mb: { xs: 4, md: 8 } }}>
    {steps.map((step, index) => (
      <Step key={index}>
        <StepLabel>{step.label}</StepLabel>
      </Step>
    ))}
  </Stepper>
);

export default FormStepper;
